<template>
  <div v-if="transaction">
    <user-details :data-user="transaction.source_user" title="Sender" hide-actions />
    <br />
    <user-details :data-user="transaction.destination_user" title="Recipient" hide-actions />

    <individual-bank-details
      class="mt-5"
      v-if="
        transaction.payment.type == 'bank_transfer' ||
        transaction.payment.type == 'instant_bank_transfer'
      "
      :payment="transaction.payment"
      :transaction="transaction"
      :owner="transaction.source_user"
    />
    <transfer-documents
      :uploadUrl="uploadUrl"
      :data-documents="transaction.documents"
      title="Upload Transfer Documents"
      :extraFields="{ type: 'transfer' }"
      class="mt-3"
    />

    <transfer-details
      :dataTransaction.sync="transaction"
      @reloadTransfer="refetchTransfer"
      class="mt-5"
    />
    <suspicion-case :transaction="transaction" class="mt-5" />
    <blockchain-transaction :transaction="transaction" />
  </div>
</template>
<script>
import UserDetails from "@/app/users/detail";
import IndividualBankDetails from "@/app/accounts/bankaccounts/IndividualBankDetails";
import TransferDetails from "./details";
import BlockchainTransaction from "./blockchaintransactions.vue";
import TransferDocuments from "./documents/index.vue";
import SuspicionCase from "../payins/suspicionCase.vue";

export default {
  components: {
    UserDetails,
    TransferDetails,
    IndividualBankDetails,
    TransferDocuments,
    BlockchainTransaction,
    SuspicionCase,
  },
  props: {
    id: {
      required: true,
    },
  },
  data: () => ({ transaction: undefined }),
  computed: {
    uploadUrl() {
      return `api/v1/transfers/${this.transaction.payment.id}/documents`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$http.get(`/api/v1/transactions/transfers/${this.id}`).then((data) => {
        this.transaction = data;
      });
    },
    async refetchTransfer({resolve, reject}) {
      try {
        const response = await this.$http.get(`/api/v1/transactions/transfers/${this.id}`);
        this.transaction = response;
        
        // Resolve the child's promise with the fresh data
        resolve(response);
        
      } catch (error) {
        console.error('Refresh failed:', error);
        reject(error);
      }
    },
  },
};
</script>
